import { render, staticRenderFns } from "./passengerflowGb.vue?vue&type=template&id=53841ee6&scoped=true&"
import script from "./passengerflowGb.vue?vue&type=script&lang=js&"
export * from "./passengerflowGb.vue?vue&type=script&lang=js&"
import style0 from "./passengerflowGb.vue?vue&type=style&index=0&id=53841ee6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53841ee6",
  null
  
)

export default component.exports